export default __webpack_public_path__ + "static/media/logo_nobg_peach.48504bc2.png";